module.exports = {
  solve: function (iframeDoc, jsCode, bodyContent) {
    return '%main-solver%';
  },
  getTestCases: function () {
    const functionName = 'totalProduct';
    const params = {
      0: ['integer', 2, 7, 1, 8, 3],
      1: ['integer', 0, 7, 2, 6, 3],
    };
    const correct = [2, 49, 3, 14, 9];
    const expectedType = ['integer'];

    return {
      type: 'cases',
      payload: { functionName, params, correct, expectedType, output: true },
    };
  },
};
